import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Card, ColorIndicator } from '@qpr/components';
import React from 'react';
import { Link } from 'react-router-dom';
import { BusinessUnit } from '../corporate-business-canvas-state';

const PREFIX = 'BusinessUnitCard';

const classes = {
  cardMui: `${PREFIX}-cardMui`,
  details: `${PREFIX}-details`,
  title: `${PREFIX}-title`,
  avatarDiv: `${PREFIX}-avatarDiv`,
  avatarImage: `${PREFIX}-avatarImage`,
  iconDiv: `${PREFIX}-iconDiv`,
  linkStyle: `${PREFIX}-linkStyle`
};

const StyledLink = styled(Link)(({ theme }) => ({
  [`& .${classes.cardMui}`]: {
    display: 'flex',
    height: '132px'
  },

  [`& .${classes.details}`]: {
    position: 'relative',
    width: '100%'
  },

  [`& .${classes.title}`]: {
    fontWeight: 500
  },

  [`& .${classes.avatarDiv}`]: {
    padding: '16px'
  },

  [`& .${classes.avatarImage}`]: {
    height: '100px',
    width: '100px',
    borderRadius: '50%'
  },

  [`& .${classes.iconDiv}`]: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: '0px',
    '& span': {
      position: 'relative',
      '&:hover': {
        bottom: '-3px'
      }
    }
  },

  [`&.${classes.linkStyle}`]: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  }
}));

interface BusinessUnitCardProps {
  item: BusinessUnit;
  inited: boolean;
}

const BusinessUnitCard = ({ inited, item }: BusinessUnitCardProps) => {
  if (!inited) return <Skeleton variant="rectangular" />;

  return (
    <StyledLink className={classes.linkStyle} to={item.titleUrl || ''}>
      <Card className={classes.cardMui}>
        <div className={classes.details} id={item.id} data-testid="card-content">
          <CardContent>
            <Typography variant="subtitle1" className={classes.title}>
              {item.title}
            </Typography>
            <Typography variant="body2">{item.subtitle}</Typography>
          </CardContent>
          <div className={classes.iconDiv} data-testid="card-icon-indicator">
            <ColorIndicator color={item.rangecolor || ''} variant="big" />
          </div>
        </div>
      </Card>
    </StyledLink>
  );
};

export default BusinessUnitCard;
